import React from "react";

import { TriggerType } from "api/model/alerts/alert-types";
import { InputNumber } from "primereact/inputnumber";
import { InputSwitch } from "primereact/inputswitch";
import { InputText } from "primereact/inputtext";
import { T } from "services/lang/LanguageService";

type TriggerSettingsEditorProps = {
  type: TriggerType;
  settings: Record<string, unknown>;
  onUpdateSettings: (key: string, value: unknown) => void;
};

const TriggerSettingsEditor: React.FC<TriggerSettingsEditorProps> = ({
  type,
  settings,
  onUpdateSettings,
}) => {
  switch (type) {
    case "DATASET_VALUE_CHANGED":
      return (
        <div className="grid">
          <div className="col-12">
            <label className="block mb-1">{T("word.dataset")} ID *</label>
            <InputText
              value={settings.datasetId as string}
              onChange={e => onUpdateSettings("datasetId", e.target.value)}
              className="w-full"
            />
          </div>
        </div>
      );

    case "DATASET_VALUE_EQUALS":
      return (
        <div className="grid">
          <div className="col-4">
            <label className="block mb-1">{T("word.dataset")} ID *</label>
            <InputText
              value={settings.datasetId as string}
              onChange={e => onUpdateSettings("datasetId", e.target.value)}
              className="w-full"
            />
          </div>
          <div className="col-4">
            <label className="block mb-1">{T("word.value")} *</label>
            <InputNumber
              value={settings.value as number}
              onValueChange={e => onUpdateSettings("value", e.value)}
              mode="decimal"
              minFractionDigits={0}
              maxFractionDigits={6}
              className="w-full"
            />
          </div>
          <div className="col-4">
            <label className="block mb-1">{T("word.tolerance")}</label>
            <InputNumber
              value={settings.tolerance as number}
              onValueChange={e => onUpdateSettings("tolerance", e.value)}
              mode="decimal"
              minFractionDigits={0}
              maxFractionDigits={6}
              className="w-full"
              placeholder="0.0001"
            />
          </div>
        </div>
      );

    case "DATASET_VALUE_IN_RANGE":
      return (
        <div className="grid">
          <div className="col-3">
            <label className="block mb-1">{T("word.dataset")} ID *</label>
            <InputText
              value={settings.datasetId as string}
              onChange={e => onUpdateSettings("datasetId", e.target.value)}
              className="w-full"
            />
          </div>
          <div className="col-3">
            <label className="block mb-1">{T("word.min")} *</label>
            <InputNumber
              value={settings.min as number}
              onValueChange={e => onUpdateSettings("min", e.value)}
              mode="decimal"
              className="w-full"
            />
          </div>
          <div className="col-3">
            <label className="block mb-1">{T("word.max")} *</label>
            <InputNumber
              value={settings.max as number}
              onValueChange={e => onUpdateSettings("max", e.value)}
              mode="decimal"
              className="w-full"
            />
          </div>
          <div className="col-3 flex align-items-end gap-2 pb-1">
            <InputSwitch
              checked={(settings.inclusive as boolean) ?? true}
              onChange={e => onUpdateSettings("inclusive", e.value)}
            />
            <label>{T("word.inclusive")}</label>
          </div>
        </div>
      );

    case "PRODUCT_TEMPLATE_VALUE_CHANGED":
      return (
        <div className="grid">
          <div className="col-6">
            <label className="block mb-1">{T("word.product-template")} *</label>
            <InputText
              value={settings.productTemplateId as string}
              onChange={e => onUpdateSettings("productTemplateId", e.target.value)}
              className="w-full"
            />
          </div>
          <div className="col-6">
            <label className="block mb-1">{T("word.field-name")} *</label>
            <InputText
              value={(settings.fieldName as string) ?? ""}
              onChange={e => onUpdateSettings("fieldName", e.target.value)}
              className="w-full"
            />
          </div>
        </div>
      );

    default:
      return null;
  }
};

export default TriggerSettingsEditor;
